import React from 'react';

function About() {
  return (
    <div>
      <h1>About</h1>
      <a href="https://youngbloodswllc.xyz">Inquiries: https://youngbloodswllc.xyz</a>
    </div>
  );
}

export default About;
